import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { JSX } from 'vue/jsx-runtime';

export const useModalStore = defineStore('modal', () => {
	const isVisible = ref(false);
	const modalHeader = ref<string>('Title');
	const modalBody = ref<string>('Body');
	const modalFooter = ref<JSX.Element>();

	const show = (header: string, body: string, footer: JSX.Element) => {
		modalHeader.value = header;
		modalBody.value = body;
		modalFooter.value = footer;
		isVisible.value = true;
	};

	const hide = () => {
		isVisible.value = false;
	};

	return {
		isVisible,
		header: modalHeader,
		body: modalBody,
		footer: modalFooter,
		show,
		hide,
	};
});
